import { render, staticRenderFns } from "./claim-messages-view.vue?vue&type=template&id=69bf56c1&scoped=true&"
import script from "./claim-messages-view.vue?vue&type=script&lang=ts&"
export * from "./claim-messages-view.vue?vue&type=script&lang=ts&"
import style0 from "./claim-messages-view.vue?vue&type=style&index=0&id=69bf56c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bf56c1",
  null
  
)

export default component.exports